import React from "react";
import { Info, Upload, X } from "lucide-react";
import signDoc from "../../../services/Documents/signDoc";

export const SignPdfModal = ({
  setCertFile,
  setUploadStatus,
  setKeyFile,
  certFile,
  keyFile,
  selectedDocument,
  updateTreeBranch,
  closeModal,
  uploadStatus,
  userId,
  parentFolderId,
  caseId,
}) => {
  const handleCertFileChange = (e) => {
    if (e.target.files[0]) {
      setCertFile(e.target.files[0]);
      setUploadStatus("");
    }
  };

  const handleKeyFileChange = (e) => {
    if (e.target.files[0]) {
      setKeyFile(e.target.files[0]);
      setUploadStatus("");
    }
  };

  const handleSignSubmit = async (e) => {
    e.preventDefault();

    if (!certFile || !keyFile) {
      setUploadStatus("Please select both certificate and key files");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("cert", certFile);
      formData.append("key", keyFile);
      formData.append("filename", selectedDocument.metadataId.name);

      if(parentFolderId !== null) formData.append("folderId",parentFolderId);
      if(caseId !== null) formData.append("caseId",caseId);

      setUploadStatus("Processing signature...");
      const signDocResponse = await signDoc(userId, formData);

      if (signDocResponse) {
        setUploadStatus("Document signed successfully");

        setTimeout(async () => {
          updateTreeBranch();
          closeModal();
        }, 1500);
      } else {
        setUploadStatus("Failed to sign document");
      }
    } catch (error) {
      console.error("Error signing document:", error);
      setUploadStatus("An error occurred while signing the document");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>

        <h3 className="text-xl font-bold mb-4">Sign Document</h3>

        <div className="mb-6 p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center mb-2">
            <Info size={16} className="text-blue-500 mr-2" />
            <h4 className="font-medium">Document Details</h4>
          </div>
          <div className="text-sm">
            <p>
              <strong>Name:</strong> {selectedDocument.title}
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {new Date(selectedDocument.CreatedAt).toLocaleDateString()}
            </p>
            <p>
              <strong>ID:</strong> {selectedDocument._id}
            </p>
            {selectedDocument.isSigned && (
              <p className="text-green-600 font-medium mt-1">
                This document is already signed
              </p>
            )}
          </div>
        </div>

        <form onSubmit={handleSignSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Certificate File (.cert)
            </label>
            <div className="flex items-center">
              <input
                type="file"
                accept=".cert"
                onChange={handleCertFileChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {certFile && (
              <p className="mt-1 text-sm text-gray-500">
                Selected: {certFile.name}
              </p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Private Key File (.key)
            </label>
            <div className="flex items-center">
              <input
                type="file"
                accept=".key"
                onChange={handleKeyFileChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {keyFile && (
              <p className="mt-1 text-sm text-gray-500">
                Selected: {keyFile.name}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={selectedDocument.isSigned}
            className={`w-full py-2 px-4 ${
              selectedDocument.signed
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            } text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-center`}
          >
            <Upload size={18} className="mr-2" />
            Sign Document
          </button>
        </form>

        {uploadStatus && (
          <div
            className={`mt-4 p-3 rounded-md ${
              uploadStatus.includes("successfully")
                ? "bg-green-100 text-green-800"
                : uploadStatus.includes("Failed") ||
                  uploadStatus.includes("Please select") ||
                  uploadStatus.includes("error")
                ? "bg-red-100 text-red-800"
                : "bg-blue-100 text-blue-800"
            }`}
          >
            {uploadStatus}
          </div>
        )}
      </div>
    </div>
  );
};
